// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"91d07a46","513":"025603ba","703":"9e24a838"}[chunkId] + ".chunk.js";
};